const isBGDark =  color  => {
    var match = /rgb\((\d+).*?(\d+).*?(\d+)\)/.exec(color);
    return ( match[1] & 255 )
        + ( match[2] & 255 )
        + ( match[3] & 255 )
        < 3 * 256 / 2;
}

export { isBGDark };


// WEBPACK FOOTER //
// ./src/utilis/isBGDark.js